import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { TEST_IDS } from "@/constants/testIds";

const faqs = [
  { q: "What is included in the ₹3,999 Couple Reset?", a: "The Couple Reset is a 60-minute premium couple wellness session at any Epsom location. The total price is ₹3,999 + 5% GST = ₹4,198.95. It includes the full session experience in a private couple suite." },
  { q: "How do I pay for the session?", a: "Payment is done directly via GPay or any UPI app. Tap the 'Pay via GPay' button or use the UPI ID provided. After payment, enter your UPI transaction reference ID to confirm your booking." },
  { q: "Is the appointment automatically confirmed?", a: "No. The selected date and time are your preference. The Epsom team confirms the actual slot after verifying your payment, via WhatsApp or phone call." },
  { q: "Can I choose another location later?", a: "Choose your preferred location during the booking form. If your preferred slot is unavailable, the Epsom team will contact you regarding alternatives across Andheri West, Santacruz West and Borivali West." },
  { q: "How will Epsom contact me?", a: "The team uses the WhatsApp number and email submitted during booking for confirmation and coordination." },
  { q: "Is this offer available for groups larger than 2?", a: "The Couple Reset offer is specifically designed for couples (2 guests). For group bookings, please contact Epsom directly." },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid={TEST_IDS.faqSection} className="py-20 sm:py-28 bg-[#0d0b09]">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }} className="text-center mb-12">
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#f2cf8b] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-[46px] font-semibold text-[#f8f0df] tracking-tight leading-tight">
            Before you <em className="italic text-[#bdb3a4]">reserve</em>
          </h2>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ delay: 0.15, duration: 0.7 }}>
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, i) => (
              <AccordionItem key={i} value={`faq-${i}`}
                className="bg-[#12100e] border border-[rgba(242,207,139,0.18)] rounded-xl px-5 py-1 data-[state=open]:shadow-md transition-shadow">
                <AccordionTrigger className="text-sm sm:text-base font-bold text-[#f8f0df] hover:text-[#f2cf8b] transition-colors text-left py-4">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-[#bdb3a4] leading-relaxed pb-4">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
